import { render, staticRenderFns } from "./ItemSearchRankSelector.vue?vue&type=template&id=05ecca58&scoped=true&"
import script from "./ItemSearchRankSelector.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchRankSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchRankSelector.vue?vue&type=style&index=0&id=05ecca58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ecca58",
  null
  
)

export default component.exports